<template>
  <article
    v-if="
      currentPage &&
        currentPage.protection &&
        currentPage.protection.locked === false
    "
    class="single-event"
    id="event-page"
  >
    <PageHeader />
    <wpImage
      v-if="currentPage.featured_image_src"
      :data="currentPage.featured_image_src"
      size="extra_large"
      class="page-featuredimage animate-delay-03"
      :lazy="true"
      :background="true"
      :hero="false"
      :placeholder="true"
      v-observe-visibility="visibilityChanged"
      :class="[baseAnimation]"
    >
      <div slot="out" v-if="isEventPast" class="past-label">
        {{ i18n.past_event_label }}
      </div>
    </wpImage>
    <main class="post-content content-two-row">
      <DynamicHtml
        v-observe-visibility="visibilityChanged"
        :class="[baseAnimation]"
        class="content padding_large"
        role="content"
        >{{ currentPage.content.rendered }}</DynamicHtml
      >
      <aside class="sidebar padding_large">
        <div
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
          v-if="
            currentPage.featured_image_src &&
              currentPage.featured_image_src.caption
          "
          class="img-description"
        >
          {{ currentPage.featured_image_src.caption }}
        </div>

        <EventMeta
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
          :id="currentPage.id"
        />

        <WrapperLink
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
          :icon="svgIcons.arrow"
          v-if="currentPage.acf.place"
          link="link"
          class="event-btn btn btn-primary road-link"
        >
          <WpLink
            class="base"
            v-if="currentPage.acf.road_link"
            :url="currentPage.acf.road_link"
            >{{ currentPage.acf.place }}</WpLink
          >
          <a
            class="base"
            target="_blank"
            :href="
              'https://www.google.com/maps/dir/Current+Location/' +
                currentPage.acf.place
            "
            v-else
            >{{ currentPage.acf.place }}</a
          >
        </WrapperLink>
        <AddToCalendar
          v-if="currentPage.acf.start_date !== ''"
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
          :title="currentPage.title.rendered.decodeHtmlEntities()"
          :description="currentPage.excerpt.rendered"
          :start="currentPage.acf.start_date"
          :end="currentPage.acf.end_date"
          :address="currentPage.acf.place ? currentPage.acf.place : ''"
        />
        <Categories
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
          v-if="currentPage.acf._categories"
          :categories="currentPage.acf._categories"
          taxonomy="event_cat"
        />

        <Share />
      </aside>
    </main>
    <div v-if="relatedPosts" class="related-posts">
      <ul class="posts-list padding_large">
        <li v-for="(post, i) in relatedPosts" :key="i">
          <SinglePost :list="true" :id="post.id" />
        </li>
      </ul>
    </div>
    <RelatedEvent
      :incoming="true"
      :data="relatedEventData"
      :exclude="currentPage.id"
    />
  </article>
  <PassProtected
    v-else-if="
      currentPage &&
        currentPage.protection &&
        currentPage.protection.locked === true
    "
  >
  </PassProtected>
</template>

<script>
import WpImage from "@/components/elements/WpImage";
import WpLink from "@/components/elements/WpLink";
import Share from "@/components/blocks/ShareBlock";
import Categories from "@/components/blocks/CategoriesBlock";
import EventMeta from "@/components/blocks/EventMeta";
import WrapperLink from "@/components/elements/WrapperLink";
import RelatedEvent from "@/components/modules/SingleEvent";
import SinglePost from "@/components/blocks/SinglePost";
import AddToCalendar from "@/components/elements/AddToCalendar";

import { isPastEvent } from "@/plugins/helpers";

import { mapGetters } from "vuex";

export default {
  name: "single-event",
  components: {
    WpImage,
    Categories,
    Share,
    EventMeta,
    WrapperLink,
    WpLink,
    RelatedEvent,
    SinglePost,
    AddToCalendar
  },
  computed: {
    ...mapGetters(["getPostsRelatedToEvent"]),
    relatedEventData() {
      return {
        select_category: this.currentPage.acf._categories,
        title: "Kanskje du er interessert i dette også?"
      };
    },
    isEventPast() {
      return this.currentPage ? isPastEvent(this.currentPage) : null;
    },
    relatedPosts() {
      let items = null;
      if (this.currentPage) {
        items = this.getPostsRelatedToEvent(this.currentPage.id);
      }
      return items;
    }
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style lang="scss">
@import "./../assets/scss/mixins.scss";
@import "./../assets/scss/vars.scss";
body .single-event {
  .past-label {
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    padding: 6px 12px;
    background-color: $dark;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 90;
  }
  .event-btn {
    position: relative;
    a,
    .text {
      display: block;
      width: 100%;
    }
    a {
      padding: 10px !important;
      font-size: 16px;
      transition: background-color 0.14s ease-in-out;
    }
    &.road-link {
      .icon svg {
        transform: rotate(-45deg);
      }
    }
    &.calendar-link {
      .icon svg {
        transform: rotate(90deg);
      }
    }
    .icon {
      position: absolute;
      top: 50%;
      right: 0px;
      transform: translateY(-50%);
      background-color: transparent !important;
      svg {
        position: relative;
        top: 2px;
        width: 24px;
        height: 24px;
      }
      svg g {
        fill: #fff !important;
      }
    }
    &:hover {
      a {
        color: $fontColor !important;
        background-color: #fff !important;
      }
      a.base {
        background-color: $fontColor !important;
        color: #fff !important;
      }
    }
  }
}
</style>
